"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrderDiscountsSortToJSON = exports.GetOrderDiscountsSortFromJSONTyped = exports.GetOrderDiscountsSortFromJSON = exports.GetOrderDiscountsSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetOrderDiscountsSort;
(function (GetOrderDiscountsSort) {
    GetOrderDiscountsSort["CreatedAt"] = "createdAt";
})(GetOrderDiscountsSort = exports.GetOrderDiscountsSort || (exports.GetOrderDiscountsSort = {}));
function GetOrderDiscountsSortFromJSON(json) {
    return GetOrderDiscountsSortFromJSONTyped(json, false);
}
exports.GetOrderDiscountsSortFromJSON = GetOrderDiscountsSortFromJSON;
function GetOrderDiscountsSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetOrderDiscountsSortFromJSONTyped = GetOrderDiscountsSortFromJSONTyped;
function GetOrderDiscountsSortToJSON(value) {
    return value;
}
exports.GetOrderDiscountsSortToJSON = GetOrderDiscountsSortToJSON;
